import app from "@/common/plugins/vueInstance";

import tipBar from "@/components/atomic/molecules/tipBar.vue";
import NaveCard from "@/components/atomic/atoms/naveCard.vue";
import DateRange from "@/components/atomic/molecules/dateRange.vue";
import Load from "@/components/atomic/molecules/load.vue";
import Tooltip from "@/components/atomic/atoms/tooltip.vue";
import SelectMonitoringAlert from "@/components/atomic/atoms/selectMonitoringAlert.vue";
import BeMaxModal from "@/components/atomic/atoms/beMaxModal.vue";
import NaveSelect from "@/components/atomic/atoms/naveSelect.vue";
import NaveCardAlert from "@/components/atomic/atoms/naveCardAlert.vue";
import DetailsDevelopment from "@/components/atomic/molecules/detailsDevelopment.vue";
import FilterSelect from "@/components/atomic/atoms/filterSelect.vue";
import BaseInput from "@/components/atomic/atoms/baseInput.vue";
import ContainerCard from "@/components/atomic/atoms/global/containerCard/ContainerCard.vue";

app.component("tip-bar", tipBar);
app.component("nave-card", NaveCard);
app.component("date-range", DateRange);
app.component("load", Load);
app.component("tooltip", Tooltip);
app.component("select-monitoring-alert", SelectMonitoringAlert);
app.component("be-max-modal", BeMaxModal);
app.component("nave-select", NaveSelect);
app.component("nave-card-alert", NaveCardAlert);
app.component("details-development", DetailsDevelopment);
app.component("filter-select", FilterSelect);
app.component("base-input", BaseInput);
app.component("w-container-card", ContainerCard);
